import { render, staticRenderFns } from "./LeftFirst.vue?vue&type=template&id=5b550138&scoped=true"
import script from "./LeftFirst.vue?vue&type=script&lang=js"
export * from "./LeftFirst.vue?vue&type=script&lang=js"
import style0 from "./LeftFirst.vue?vue&type=style&index=0&id=5b550138&prod&lang=scss"
import style1 from "./LeftFirst.vue?vue&type=style&index=1&id=5b550138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b550138",
  null
  
)

export default component.exports